import { css } from '@inter-ikea-kompis/web-component';
import { Text } from '@ingka/common-styles-webc';
export default class ProductCardTippingHazardWarningStyle {
    static getStyle() {
        return css `
			${Text.CSS}

			:host {
				display: flex;
			}

			img {
				display: block;
				max-height: ${40 / 16}rem;
			}

			p {
				margin: 0;
				padding: 0;
			}
		`;
    }
}
//# sourceMappingURL=ProductCardTippingHazardWarningStyle.js.map